import FormattedMessage from 'I18n/components/FormattedMessage';
import { DuplicateIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BulkCopyAssetsButton({
  hasAssetCopierAccess,
  onClick
}) {
  if (!hasAssetCopierAccess) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Link, {
    "data-test-id": "bulk-copy-assets-link",
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(DuplicateIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.bulkActions.copyToOtherAccount"
    })]
  });
}
export default /*#__PURE__*/memo(BulkCopyAssetsButton);